import React from 'react'
import Helmet from 'react-helmet'
import { EmptyContainer, Spinner } from 'lib/ui'
import { useCoreContext, useMain } from 'lib/core/hooks'
import { ErrorBoundary, LoggedOutModal, Maintenance } from 'lib/modules/shared'

interface Props {
  children: React.ReactElement | React.ReactElement[]
  layout: (props: { children: React.ReactElement }) => React.ReactElement
}

export const Main = ({ children, layout: LayoutComponent }: Props) => {
  const { onError } = useCoreContext()
  const { isLoading, storeConfigError } = useMain()

  return (
    <ErrorBoundary
      onError={onError}
      layout={LayoutComponent}
    >
      <>
        <Helmet>
          <title>{process.env.REACT_APP_TITLE}</title>
        </Helmet>
        {storeConfigError ? <Maintenance /> : (isLoading ? (
          <LayoutComponent>
            <EmptyContainer>
              <Spinner />
            </EmptyContainer>
          </LayoutComponent>
        ): children)}
        <LoggedOutModal />
      </>
    </ErrorBoundary>
  )
}
